import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Anchor } from 'lucide-react';
import { Button } from '../components/ui/button';

export const MentionsLegales = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 lg:px-8 py-4">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/')}
              className="flex items-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Retour
            </Button>
            <div className="flex items-center gap-2">
              <Anchor className="w-5 h-5 text-blue-600" />
              <span className="font-semibold text-lg">The Myli Boat</span>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Mentions Légales</h1>

        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8">
          
          {/* Éditeur du site */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Éditeur du site</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>Nom commercial :</strong> The Myli Boat</p>
              <p><strong>Dénomination sociale :</strong> ZEMMOUR Salim</p>
              <p><strong>Forme juridique :</strong> Entrepreneur individuel (Micro-entreprise)</p>
              <p><strong>SIREN :</strong> 850 462 664</p>
              <p><strong>SIRET :</strong> 850 462 664 00036</p>
              <p><strong>Numéro d'immatriculation :</strong> SIREN 850 462 664 au RNE (Registre National des Entreprises)</p>
              <p><strong>Date de création :</strong> 01/04/2026</p>
              <p><strong>Code APE :</strong> 7711A - Location de courte durée de voitures et de véhicules automobiles légers</p>
              <p><strong>Activité :</strong> Location de véhicule marin avec ou sans prestation de service de Skipper</p>
              <p className="mt-4 p-3 bg-blue-50 rounded-lg border-l-4 border-blue-600">
                <strong>TVA :</strong> TVA non applicable, article 293 B du Code Général des Impôts (franchise en base de TVA)
              </p>
            </div>
          </section>

          {/* Siège social */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Siège social</h2>
            <div className="text-gray-700">
              <p>40 Avenue de Hambourg</p>
              <p>13008 Marseille</p>
              <p>FRANCE</p>
            </div>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Contact</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>Email :</strong> <a href="mailto:TheMyliBoat@gmail.com" className="text-blue-600 hover:underline">TheMyliBoat@gmail.com</a></p>
              <p><strong>Téléphone :</strong> <a href="tel:0644731667" className="text-blue-600 hover:underline">06 44 73 16 67</a></p>
              <p><strong>Site web :</strong> <a href="https://www.themyliboat.com" className="text-blue-600 hover:underline">www.themyliboat.com</a></p>
            </div>
          </section>

          {/* Directeur de publication */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Directeur de la publication</h2>
            <p className="text-gray-700">M. ZEMMOUR Salim</p>
          </section>

          {/* Hébergement */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Hébergement du site</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>Hébergeur :</strong> Emergent</p>
              <p><strong>Site web :</strong> <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://emergent.sh</a></p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Propriété intellectuelle</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. 
                Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
              <p>
                La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite 
                sauf autorisation expresse du directeur de la publication.
              </p>
              <p>
                Les marques, logos, images, et tous autres signes distinctifs figurant sur ce site sont la propriété exclusive de The Myli Boat 
                et ne peuvent être reproduits sans l'autorisation expresse de la société.
              </p>
            </div>
          </section>

          {/* Données personnelles */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Protection des données personnelles</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, modifiée par la loi n°2004-801 du 6 août 2004, 
                et au Règlement Général sur la Protection des Données (RGPD) du 27 avril 2016, vous disposez d'un droit d'accès, de rectification, 
                de suppression et d'opposition aux données personnelles vous concernant.
              </p>
              <p>
                Pour exercer ce droit, vous pouvez nous contacter par email à l'adresse : <a href="mailto:TheMyliBoat@gmail.com" className="text-blue-600 hover:underline">TheMyliBoat@gmail.com</a>
              </p>
              <p>
                Pour plus d'informations, consultez notre <a href="/politique-confidentialite" className="text-blue-600 hover:underline font-semibold">Politique de Confidentialité</a>.
              </p>
            </div>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Cookies</h2>
            <p className="text-gray-700">
              Le site www.themyliboat.com peut être amené à vous demander l'acceptation des cookies pour des besoins de statistiques et d'affichage. 
              Un cookie est une information déposée sur votre disque dur par le serveur du site que vous visitez.
            </p>
          </section>

          {/* Responsabilité */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Limitation de responsabilité</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Les informations contenues sur ce site sont aussi précises que possibles et le site est périodiquement remis à jour, 
                mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes.
              </p>
              <p>
                The Myli Boat ne pourra être tenu responsable des dommages directs et indirects causés au matériel de l'utilisateur, 
                lors de l'accès au site www.themyliboat.com.
              </p>
            </div>
          </section>

          {/* Droit applicable */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Droit applicable et juridiction compétente</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Les présentes mentions légales sont soumises au droit français.
              </p>
              <p>
                En cas de litige et à défaut d'accord amiable, le tribunal compétent sera celui du ressort du siège social de The Myli Boat.
              </p>
            </div>
          </section>

          {/* Paiement en ligne */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Paiement en ligne</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Les paiements en ligne sont sécurisés par notre prestataire de paiement <strong>Stripe</strong>.
              </p>
              <p>
                Les données bancaires ne sont pas stockées sur nos serveurs. Elles transitent de manière sécurisée et cryptée 
                directement vers Stripe qui est certifié PCI-DSS niveau 1 (le plus haut niveau de certification dans l'industrie des paiements).
              </p>
            </div>
          </section>

          {/* Date de mise à jour */}
          <section className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </section>

        </div>

        {/* Liens vers autres pages légales */}
        <div className="mt-8 grid md:grid-cols-2 gap-4">
          <Button
            variant="outline"
            onClick={() => navigate('/cgv')}
            className="w-full py-6"
          >
            📄 Conditions Générales de Vente
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/politique-confidentialite')}
            className="w-full py-6"
          >
            🔒 Politique de Confidentialité
          </Button>
        </div>

        {/* Retour accueil */}
        <div className="mt-8 text-center">
          <Button
            onClick={() => navigate('/')}
            className="bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900"
          >
            Retour à l'accueil
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
